import React, { useEffect, useState } from 'react'
import { Box, Checkbox, Divider, FormControlLabel, Grid, Typography } from '@mui/material'
import ImgSugguest00 from "../../../assets/Image/ImgSugguest/0.jpg";
import ImgSugguest02 from "../../../assets/Image/ImgSugguest/3.jpg";
import EditPurpleIcon from "../../../assets/Image/EditPurpleIcon.png";
// yup
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import yupFormSchemas from 'components/Common/FormItem/yup/yupFormSchemas';
import InputFormItem from 'components/Common/ElementInForm/InputFormItem';
import { BtnSend } from 'components/Common/Button';
import InputCustomLabel from 'components/Common/ElementInForm/InputCustomLabelFormItem';
import useMediaQuery from '@mui/material/useMediaQuery';
import { SwAlert } from 'components/Common/Alert/AlertForm';
import { AlertTitle, AxiosGet, AxiosPost, ResultAPI } from 'service/CommonFunction/TS_function';
import { SnackbarCustom } from 'components/Common/Alert/Snackbars/Snackbar';
import moment from 'moment';
import { Link } from 'react-router-dom';
import AOS from "aos";
import { i18n } from 'i18n';
import { FnBlock_UI } from 'service/SystemFunction/SystemFunction';
import { currentLanguage } from 'service/CommonFunction/AxiosConfig';
import DatePickerLangFormItem from 'components/Common/ElementInForm/DatePickerLangFormItem';

const i18nField = 'entities.Suggestion.fields';

const SuggestionForm = () => {

    const { BlockUI, UnBlockUI } = FnBlock_UI();

    const Layout900 = useMediaQuery('(min-width:900px)');
    const Layout600 = useMediaQuery('(min-width:600px)');

    const [DataUser, setDataUser] = useState({
        "nUserID": null,
        "sUserCode": null,
        "sFullname": null,
        "sAPIRoleName": null,
        "sUserType": null,
        "lstCompany": [],
        "lstUserBA": []
    })

    const [oCompany, setoCompany] = useState(null) as any;
    const [oAddress, setoAddress] = useState(null) as any;
    const [oTel, setoTel] = useState(null) as any;
    const [IsAddTelExtention, setIsAddTelExtention] = useState(false)
    const [nCountInputTel, setnCountInputTel] = useState(0)

    //SnankBar
    const [IsOpenSnackbar, setIsOpenSnackbar] = useState(false)
    const [sSeveritySnackbar, setsSeveritySnackbar] = useState("success")
    const [sMessageSnackbar, setsMessageSnackbar] = useState(null) as any

    const schema = yup.object().shape({
        sDetail: yupFormSchemas.string(i18n(`${i18nField}.sFeedback`), { required: true }),
        sFname: yupFormSchemas.string(i18n(`${i18nField}.sFirstname`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sLname: yupFormSchemas.string(i18n(`${i18nField}.sLastname`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        sCompany: yupFormSchemas.string(i18n(`${i18nField}.sCompany`), { required: DataUser.nUserID != null && DataUser.sUserType === "C" ? false : true }),
        // sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: false }),
        sInputTel: yupFormSchemas.string(i18n(`${i18nField}.sTel`), { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: false, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        // sInputTelExtension: yupFormSchemas.string(i18n(`${i18nField}.sTelExtension`), { required: IsAddTelExtention, max: 10, matches: /^[0-9]{0,10}$/, labelmatches: i18n(`${i18nField}.sMatchTel`) }),
        sEmail: yupFormSchemas.email(i18n(`${i18nField}.sEmail`), { required: false }),
    });
    const form = useForm({
        resolver: yupResolver(schema),
        mode: 'all',
        shouldFocusError: true,
        criteriaMode: "firstError"
    })

    useEffect(() => {
        AOS.init({
            duration: 1200,
        });
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth",
        });
        GetUserData();
    }, [])

    //#region Get data Form API
    const GetUserData = async () => {
        let sUserID = "";
        let nUserID = 0;


        await AxiosGet("User/GetUserData", { "sLanguage": currentLanguage() }, (res) => {
            ResultAPI(res, null, () => {
                nUserID = res.result.nUserID;
                let lstIntBA = (res.result.lstUserBA || []).map(m => m.nBAID);
                setDataUser({
                    "nUserID": res.result.nUserID || null,
                    "sUserCode": res.result.sUserCode || "",
                    "sFullname": res.result.sFullname || "",
                    "sAPIRoleName": res.result.sAPIRoleName || "",
                    "sUserType": res.result.sUserType || "",
                    "lstCompany": res.result.lstCompany || [],
                    "lstUserBA": lstIntBA || [],
                });
            })
        })

        if (nUserID != 0) {
            await AxiosGet(`MasterData/EncrypData`, { "sDataEncryp": nUserID }, (res) => {
                ResultAPI(res, null, () => {
                    sUserID = res.result;
                })
            });

            await AxiosGet(`Customer/GetDefaultDataCustomerNoPIS`, { "sUserID": sUserID }, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    setoCompany(res.oDefaultCompany ?? null)
                    setoAddress(res.oDefaultAddress ?? null)
                    setoTel(res.oDefaultTel ?? null)
                    // form.setValue("sEmail", res.sEmail ?? null)

                })
            });
        }
    };


    const SaveDataSuggest = () => {
        let param = {
            "nJobTypeID": 3,        //1 ข้อร้องเรียน //2 ข้อร้องขอ //3ข้อเสนอแนะ
            "sMode": "N",       //เปิดใหม่
            "nCustomerID": DataUser.sUserType === "C" ? DataUser.nUserID : null,
            "nCompanyID": DataUser.sUserType === "C" && oCompany ? parseInt(oCompany.value) : null,
            "nTelID": DataUser.sUserType === "C" && oTel ? parseInt(oTel.value) : null,
            "nAddrID": DataUser.sUserType === "C" && oAddress ? parseInt(oAddress.value) : null,

            "cCustomerType": DataUser.sUserType === "C" ? "E" : "P",        //E customer
            "nVOCFormTypeID": 3,    //1 แจ้งปัญหา //2 สนใจผลิตภัณฑ์และบริการ //3 คำแนะนำติชม
            "sDetail": form.getValues("sDetail") ?? null,
            "sExternal_FName": form.getValues("sFname") ?? null,
            "sExternal_LName": form.getValues("sLname") ?? null,
            "sExternal_CompanyName": form.getValues("sCompany") ?? null,
            "sExternal_Tel": form.getValues("sInputTel") ?? null,
            "sExternal_Tel_Extension": form.getValues("sInputTelExtension") ?? null,
            "sExternal_Email": form.getValues("sEmail") ?? null,
            "IsCreateVOCByBA": false,
            "sIssueDate": moment().format("DD/MM/YYYY HH:mm"),

        }

        let sMessage = currentLanguage() == "th" ? "คุณต้องการที่จะส่งคำแนะนำติชมใช่หรือไม่ ?" : "Do you want to send suggestion ?";
        SwAlert.Confirm(AlertTitle.Confirm, sMessage, () => {
            BlockUI();
            AxiosPost(`VOC/SaveVOCSuggest`, param, (res) => {
                UnBlockUI();
                ResultAPI(res, null, () => {
                    if (res.statusCode === 200) {
                        onClearData();
                        setIsOpenSnackbar(true);
                        let sSuccess = currentLanguage() == "th" ? "บันทึกข้อมูลสำเร็จ" : "Data is already saved."
                        setsMessageSnackbar(sSuccess)
                        setsSeveritySnackbar("success")

                    }
                    else {
                        setIsOpenSnackbar(true);
                        setsMessageSnackbar(res.Message)
                        setsSeveritySnackbar("warning")

                    }
                })
            }, null, null)
        })
    }

    const onClearData = () => {
        Object.keys(form.getValues()).forEach((key => {
            form.setValue(key, null);
            form.clearErrors(key);
        }))
    }

    return (
        <>
            <div style={{ position: 'relative' }}>
                <div style={{ position: 'absolute', top: !Layout900 ? '50%' : '40%', left: '10%' }}>
                    <Typography style={{ lineHeight: "1", color: '#ffffff' }}>
                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.4em" : "3em" }}>
                            {i18n(`${i18nField}.sSuggestion`)}
                        </span>{" "}
                        <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                            <Grid item>
                                <Link to="/Home" preventScrollReset={true}>
                                    <span style={{ fontWeight: "400", color: '#ffffff', fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                        {i18n(`${i18nField}.sHomepage`)}
                                    </span>
                                </Link>
                            </Grid>
                            <Grid item>
                                <Divider orientation='vertical' style={{ height: '30px', backgroundColor: '#ffffff' }} />
                            </Grid>
                            <Grid item>
                                <span style={{ fontWeight: "400", fontSize: !Layout900 ? "0.8em" : "1em" }}>
                                    <b> {i18n(`${i18nField}.sSuggestion`)}</b>
                                </span>
                            </Grid>
                        </Grid>
                    </Typography>
                </div>
                <img src={ImgSugguest00} alt='' style={{ width: '100%', minHeight: '250px', objectFit: 'cover', boxShadow: '1px 1px 10px 4px rgb(0 0 0 / 20%)' }} />
            </div>
            <Grid container spacing={!Layout900 ? 2 : 4} direction="row" justifyContent="center" alignItems="end" style={{ marginTop: '1em' }}>
                <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="end" style={!Layout900 ? { paddingLeft: '2em' } : {}}>
                        <Grid item xs={12} md={4} >
                            <Typography style={{ lineHeight: "0.9", color: '#202178' }}>
                                <span style={{ fontWeight: "700", display: "flex", fontSize: Layout900 ? "3.5em" : Layout600 ? "2.5em" : "2em" }}>
                                    GBU
                                </span>{" "}
                                <span style={{ fontWeight: "200", fontSize: Layout900 ? "3.5em" : Layout600 ? "2.5em" : "2em" }}>
                                    SUGGESTION
                                </span>
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6} >
                            <Grid container spacing={2} direction="row" justifyContent="start" alignItems="center">
                                <Grid item >
                                    <div style={{ backgroundColor: "#ffffff", borderRadius: '50%', border: '1px solid #202178', width: '3em', height: '3em', display: 'flex', padding: '20%' }}>
                                        {/* <img src={EditPurpleIcon} alt='' style={{ width: '100%' }} /> */}
                                        <Box
                                            component="div"
                                            sx={{
                                                flexGrow: 1,
                                                backgroundImage: `url(${EditPurpleIcon})`,
                                                backgroundSize: "cover",
                                                backgroundRepeat: "no-repeat",
                                                objectFit: 'contain',
                                                cursor: 'pointer',
                                                // height: '43px',
                                                width: '100%',
                                                // margin:'7px'
                                            }}
                                        />
                                    </div>
                                </Grid>
                                <Grid item >
                                    <Typography style={{ lineHeight: "0.9", color: '#202178' }}>
                                        <span style={{ fontWeight: "400", display: "flex", fontSize: !Layout900 ? "1.2em" : "1.7em" }}>
                                            {i18n(`${i18nField}.sPlease`)}
                                        </span>{" "}
                                        <span style={{ fontWeight: "400", fontSize: !Layout900 ? "1.2em" : "1.7em" }}>
                                            {i18n(`${i18nField}.sCompleteInfo`)}
                                        </span>
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
                <Divider style={{ width: '100%', marginTop: '1em' }} />

                <Grid item xs={12}>
                    <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ marginBottom: '1em' }}>
                        {Layout900 && <Grid item xs={12} md={4} data-aos="fade-right">
                            <img src={ImgSugguest02} alt='' style={{ width: '70%', borderRadius: '170px', height: '550px', objectFit: 'cover' }} />
                        </Grid>}
                        <Divider orientation="vertical" variant="middle" flexItem style={{ display: !Layout900 ? 'none' : 'block', margin: '24px 8px 4px', border: '0.5px solid #d4d4d4', backgroundColor: '#d4d4d4' }} />
                        <Grid item xs={12} md={!Layout900 ? 12 : 6} data-aos="fade-left">
                            <FormProvider {...form}>
                                <Grid container spacing={2} direction="row" justifyContent="center" alignItems="start" style={{ padding: !Layout900 ? '2em' : '6em 2em 2em 2em' }}>
                                    <Grid item xs={12} >
                                        <InputCustomLabel
                                            id="sDetail"
                                            name="sDetail"
                                            label={i18n(`${i18nField}.sFeedback`)}
                                            required={true}
                                            multiline={true}
                                            maxLength={1000}
                                            rows={DataUser.nUserID != null && DataUser.sUserType === "C" ? 6 : 4}
                                            fullWidth
                                        />
                                    </Grid>
                                    {
                                        DataUser.nUserID != null && DataUser.sUserType === "C"
                                            ?
                                            null
                                            :
                                            <>
                                                <Grid item xs={12} md={6}>
                                                    <InputFormItem
                                                        id="sFname"
                                                        name="sFname"
                                                        label={i18n(`${i18nField}.sFirstname`)}
                                                        required={true}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} md={6}>
                                                    <InputFormItem
                                                        id="sLname"
                                                        name="sLname"
                                                        label={i18n(`${i18nField}.sLastname`)}
                                                        required={true}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                <Grid item xs={12} >
                                                    <InputFormItem
                                                        id="sCompany"
                                                        name="sCompany"
                                                        label={i18n(`${i18nField}.sCompany`)}
                                                        required={true}
                                                        fullWidth
                                                    />
                                                </Grid>
                                                {/* <Grid item xs={12} md={6}>
                                                    <InputFormItem
                                                        id="sInputTel"
                                                        name="sInputTel"
                                                        label={i18n(`${i18nField}.sTel`)}
                                                        required={false}
                                                        fullWidth
                                                    />
                                                </Grid> */}
                                                <Grid item xs={12}>
                                                    <Grid container spacing={2} direction="row" justifyContent="start" alignItems="start">
                                                        <Grid item xs={12} sm={12} md={5}>
                                                            <InputFormItem
                                                                id="sInputTel"
                                                                name="sInputTel"
                                                                label={i18n(`${i18nField}.sTel`)}
                                                                required={false}
                                                                maxLength={10}
                                                                fullWidth
                                                                onChange={(e)=>{
                                                                    if(e == "")
                                                                    {
                                                                        setIsAddTelExtention(false);
                                                                    }
                                                                }}
                                                            />
                                                        </Grid>
                                                        {   <Grid item xs={12} sm={12} md={'auto'}>
                                                            <FormControlLabel
                                                                control={
                                                                    <Checkbox
                                                                        checked={IsAddTelExtention}
                                                                        disabled={(!form.getValues("sInputTel"))}
                                                                        onChange={() => {
                                                                            setIsAddTelExtention(!IsAddTelExtention);
                                                                            form.setValue("sInputTelExtension", null)
                                                                            form.clearErrors("sInputTelExtension")
                                                                        }}
                                                                    />
                                                                }
                                                                label={i18n(`${i18nField}.sTelExtension`)}
                                                                labelPlacement="end"
                                                            />
                                                        </Grid>}
                                                        {IsAddTelExtention &&
                                                            <Grid item xs={12} sm={12} md={3}>
                                                                <InputFormItem
                                                                    id="sInputTelExtension"
                                                                    name="sInputTelExtension"
                                                                    label={i18n(`${i18nField}.sTelExtension`)}
                                                                    required={false}
                                                                    fullWidth
                                                                    maxLength={10}
                                                                    />
                                                            </Grid>
                                                        }
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <InputFormItem
                                                        id="sEmail"
                                                        name="sEmail"
                                                        label={i18n(`${i18nField}.sEmail`)}
                                                        required={false}
                                                        fullWidth
                                                    />
                                                </Grid>
                                            </>
                                    }
                                    <Grid item >
                                        <BtnSend txt={i18n(`${i18nField}.sSendFeedback`)} onClick={form.handleSubmit(() => { SaveDataSuggest() })} />
                                    </Grid>
                                </Grid>
                            </FormProvider>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <SnackbarCustom
                IsOpen={IsOpenSnackbar}
                Severity={sSeveritySnackbar}
                OnClose={() => { setIsOpenSnackbar(false) }}
                Message={sMessageSnackbar}
            />
        </>

    )
}

export default SuggestionForm